module.exports = __webpack_public_path__ + "static/PaintChips.a48cc0c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/PaintChips.png
// module id = 131
// module chunks = 35783957827783 188029690210722